import React, {useEffect, useState, useRef} from 'react'
import {IconButton, Typography, TextField, Grid} from '@material-ui/core'
import InputAdornment from '@material-ui/core/InputAdornment'
import CloseIcon from '@material-ui/icons/Close'
import SearchIcon from '@material-ui/icons/Search'

const FilterFIelds = ({options, handleClickOption, value, values, open}) => {
  const [filteredOptions, setFilteredOptions] = useState([])
  const [isSearching, setSearching] = useState(false)
  const [search, setSearch] = useState('')
  const [realSearch, setRealSearch] = useState('')
  const refSearch = useRef(null)

  useEffect(() => {
    let _filteredOptions = []
    let filterTypes = [
      'EntityListField',
      'MultipleEntityListField',
      'ApUserField',
      'StatusField',
      'ListField',
      'MultipleListField',
      'YesNoField',
    ]
    options.map(o => {
      if (
        filterTypes.includes(o.field_type) &&
        o.field_name.toLowerCase().match(realSearch.toLowerCase())
      ) {
        _filteredOptions.push(o)
      }
      return true
    })

    setFilteredOptions(_filteredOptions)
  }, [options, realSearch, value, values, open])

  const handleSearch = e => {
    if ('Enter' === e.key) {
      setRealSearch(search)
    } else {
      setSearching(true)
    }
  }

  const handleSearchText = e => {
    e.preventDefault()
    setSearch(e.target.value)
    if (e.target.value === '') {
      setRealSearch('')
    }
  }

  const isSelected = id => {
    if (value && (value?.field_id === id || value?.id === id)) {
      return true
    }
    return false
  }

  const onCloseSearch = () => {
    if (refSearch.current) {
      refSearch.current.focus()
    }
    setSearch('')
    setRealSearch('')
    setSearching(false)
  }

  return (
    <>
      <div className="c-res-mod ap-list ap-scrollbar filter-field-container">
        <Grid container className="position-relative mb-30" xs={12}>
          {isSearching ? (
            <Grid item xs={10} className="search-option-body-gantt-filter">
              <TextField
                ref={refSearch}
                id="standard-basic"
                type="text"
                className="c-res-mod ap-list ap-scrollbar"
                autoFocus
                value={search}
                onChange={handleSearchText}
                onKeyDown={e => handleSearch(e)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <div isDisabled={true}>
                        <CloseIcon className="cursor-pointer" onClick={() => onCloseSearch()} /> |{' '}
                      </div>
                      <IconButton
                        type="submit"
                        className="ap-icon-button p-0"
                        underline={false}
                        aria-label="search"
                        onClick={() => {
                          if (isSearching === true && search.length !== 0) {
                            setRealSearch(search)
                          } else {
                            setSearching(true)
                          }
                        }}
                      >
                        <SearchIcon className="filter-search-icon" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          ) : (
            <Grid xs={10} className="fields-grid">
              <Typography className="fields-grid-heading font-16 field-value-text">
                Fields
              </Typography>
              <IconButton
                type="submit"
                className="ap-icon-button p-0"
                underline={false}
                aria-label="search"
                onClick={() => {
                  if (isSearching === true && search.length !== 0) {
                    setRealSearch(search)
                  } else {
                    setSearching(true)
                  }
                }}
              >
                <SearchIcon className="filter-search-icon" />
              </IconButton>
            </Grid>
          )}
        </Grid>

        <div className="ap-list__wrapper p-0 filter-field-item-list overflow-auto scroll-bar-style">
          {filteredOptions.map((o, i) => (
            <div
              key={i}
              className={`width-98-per cursor-pointer border-radius-4 ap-list__item ap-typography ap-typography--sm ap-flex ap-flex--start ap-flex--align-center c-pop-field-toggle__option
              ${
                isSelected(o.field_id) ? 'selected_filter_selected_value' : ''
              } filter-item-list word-break-all`}
              onClick={e => handleClickOption(e, o)}
            >
              {o.field_name}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default FilterFIelds
